// Firebase Configuration
// Project: cashboomerang-a3d6f
// Generated: 2025-12-16

export const configOptions = {
  apiKey: "AIzaSyDR0MPL0RiDNmx7rqkHuk_CRyQGG4h83lI",
  authDomain: "cashboomerang-a3d6f.firebaseapp.com",
  projectId: "cashboomerang-a3d6f",
  storageBucket: "cashboomerang-a3d6f.firebasestorage.app",
  messagingSenderId: "67144438654",
  appId: "1:67144438654:web:3107d9079efd010022d92f",
  measurementId: "G-6VFV4HZV1V"
};
